import { useBusiness } from './businesses';
import { ExportStatus, Transaction } from '~/types';
import { useIndividual } from './individuals';
import { useMutation, useQuery } from 'react-query';
import {
  getTransactionsExport,
  getTransactionsExportCheck,
  getTransactionsExportStatus,
} from '~/api/transactions';

export const useOriginator = (originator: Transaction['originator']) => {
  const individualId = originator?.profileType === 'INDIVIDUAL' ? originator.profileId : undefined;
  const businessId = originator?.profileType === 'BUSINESS' ? originator.profileId : undefined;

  const individualQuery = useIndividual(individualId);
  const businessQuery = useBusiness(businessId);

  if (originator?.profileType === 'INDIVIDUAL') {
    return {
      profileType: 'INDIVIDUAL',
      data: individualQuery.data,
      isLoading: individualQuery.isLoading,
    };
  }
  if (originator?.profileType === 'BUSINESS') {
    return {
      profileType: 'BUSINESS',
      data: businessQuery.data,
      isLoading: businessQuery.isLoading,
    };
  }
  return {};
};

export const useTransactionExportCheck = () => {
  return useQuery(['transactionExportCheck'], getTransactionsExportCheck);
};

export const useExportStatus = (exportId: string | null) => {
  return useQuery<ExportStatus>(
    ['exportStatus', exportId],
    exportId ? () => getTransactionsExportStatus(exportId) : () => Promise.resolve(),
    { enabled: !!exportId, refetchInterval: 2000 }
  );
};

export const useCreateExportTask = () => {
  return useMutation(getTransactionsExport);
};
